import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { ICustomResponse, customResponse } from 'cloud-shared-lib';
import { Observable } from 'rxjs';

@Injectable()
export class CadModelMaterialsMatchingService {
  constructor(private http: HttpClient) {}

  getMateBaseSlots(): Observable<ICustomResponse<string[]>> {
    return this.http.get(ApiLinks.matBaseSlots).pipe(customResponse<string[]>());
  }
}
